import { ChangeDetectionStrategy, Component, Signal, computed, input, signal } from '@angular/core';

import { CsImageIconComponent } from '@frontend/casino-ui';

import { JackpotValueFormatterPipe } from './jackpot-value-formatter.pipe';
import { JackpotValueModel } from './jackpot-value.model';

@Component({
    selector: 'cs-jackpot-ribbon',
    templateUrl: './jackpot-ribbon.component.html',
    styleUrl: './jackpot-ribbon.component.scss',
    imports: [CsImageIconComponent, JackpotValueFormatterPipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JackpotRibbonComponent {
    private _currentValue = signal<JackpotValueModel | undefined>(undefined);
    isJackpotGroup = signal<boolean>(false);

    isLegacy = input<boolean>(true);
    iconImage = input<string>('');
    jackpotValue = input<JackpotValueModel>();
    alignment = input<JackpotRibbonAlignment>('centered');
    withIcon = input<boolean>(true);
    withAmount = input<boolean>(true);
    withCurrency = input<boolean>(true);
    withCurrencyOnRight = input<boolean>(false);
    customClass = input<string>('');

    get currentValue(): Signal<JackpotValueModel | undefined> {
        return computed(() => this._currentValue() || this.jackpotValue());
    }

    set currentValue(jpValue: JackpotValueModel | undefined) {
        this._currentValue.set(jpValue);
    }
}

export type JackpotRibbonAlignment = 'centered' | 'left';
